import React from "react";
import "./input.css";

export default function Input({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
  helpText,
  className = "",
  ...props
}) {
  const inputId = name || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`input-field ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-field__label">
          {label}
          {required && <span className="input-field__required"> *</span>}
        </label>
      )}
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`input-field__input ${error ? "input-field__input--error" : ""}`}
        {...props}
      />
      {helpText && !error && (
        <small className="input-field__help">{helpText}</small>
      )}
      {error && <small className="input-field__error">{error}</small>}
    </div>
  );
}
